import styled from '@emotion/styled';

export const AddContentFormDiv = styled.div`
  flex-grow: 1;
  max-height: calc(100% - 122px);
  overflow: auto;
`;

export const AddContentFormRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  max-height: calc(100% - 50px);
  height: 100%;

  > :first-of-type {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    border-right: solid rgba(100, 100, 100, 0.2) 1px;
    /* min-width: 322px; */
    max-width: 299px;
  }
`;

export const AddContentFormColumn = styled.div`
  overflow: auto;
  flex: 2;
  padding: 16px;
  max-height: 100%;
`;

export const AddContentFormButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -16px;
  border-top: solid rgba(100, 100, 100, 0.2) 1px;
  justify-content: center;
  height: 60px;
  align-items: center;
  background-color: #fff;

  > button {
    margin: 0 8px;
  }
`;

export const AddContentFormModalContent = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const AddContentFormModalSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
`;

export const AddContentFormContainer = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;

  .MuiFormControl-marginDense {
    margin: 0;
  }
`;
